var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerSpecialize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 46,
    viewBox: "0 0 39 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_8508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 41.5C18.1644 41.5 17.8315 41.3696 17.5738 41.1116L6.47315 29.8796C-0.157718 23.1703 -0.157718 12.2508 6.47315 5.54147C9.68658 2.29005 13.9577 0.5 18.5 0.5C23.0423 0.5 27.3134 2.29005 30.5268 5.54147C37.1577 12.2508 37.1577 23.1676 30.5268 29.8796L19.4262 41.1116C19.1711 41.3696 18.8356 41.5 18.5 41.5Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 41.5C18.1644 41.5 17.8315 41.3696 17.5738 41.1116L6.47315 29.8796C-0.157718 23.1703 -0.157718 12.2508 6.47315 5.54147C9.68658 2.29005 13.9577 0.5 18.5 0.5C23.0423 0.5 27.3134 2.29005 30.5268 5.54147C37.1577 12.2508 37.1577 23.1676 30.5268 29.8796L19.4262 41.1116C19.1711 41.3696 18.8356 41.5 18.5 41.5Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 26.5V13.0789H25.7C26.195 13.0789 26.6188 13.2542 26.9713 13.6046C27.3238 13.955 27.5 14.3763 27.5 14.8684V24.7105C27.5 25.2026 27.3238 25.6239 26.9713 25.9743C26.6188 26.3248 26.195 26.5 25.7 26.5H23.9ZM16.7 13.0789H20.3V11.2895H16.7V13.0789ZM14.9 26.5V11.2895C14.9 10.7974 15.0763 10.3761 15.4288 10.0257C15.7813 9.67522 16.205 9.5 16.7 9.5H20.3C20.795 9.5 21.2188 9.67522 21.5713 10.0257C21.9238 10.3761 22.1 10.7974 22.1 11.2895V26.5H14.9ZM11.3 26.5C10.805 26.5 10.3813 26.3248 10.0288 25.9743C9.67625 25.6239 9.5 25.2026 9.5 24.7105V14.8684C9.5 14.3763 9.67625 13.955 10.0288 13.6046C10.3813 13.2542 10.805 13.0789 11.3 13.0789H13.1V26.5H11.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_8508",
    x: 0,
    y: 0,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_8508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_8508",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSpecialize);
export default __webpack_public_path__ + "static/media/marker_specialize.7b682d891a9bfca883e623dd3d631037.svg";
export { ForwardRef as ReactComponent };